<template>
  <Layout>
    <PageHeader :title="title" :items="items" :backButton="true" :prevRoutePath="backUrl"/>
    <div class="row mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-sm-6">
                  <div class="media">
                  <div class="avatar-sm mr-3">
                    <span class="avatar-title rounded-circle bg-light text-primary font-size-22">
                      <i class="bx bxl-telegram"></i>
                    </span>
                  </div>
                  <div class="media-body">
                    <h4 class="mt-3">{{ $t('telegram.grup-messanger') }}</h4>
                  </div>
                </div>
                </div>
                <div class="col-sm-6 text-right mt-3">
                    <span class="text-secondary btn btn-sm btn-light mr-1" v-if="created_at_grouplistdetail">{{ $t('telegram.updated') }}: {{formatDateRefresh(created_at_grouplistdetail)}}</span> 
                    <b-button class="btn btn-sm" variant="success" @click="getGroupDetailTelegram"><span v-if="loadingupdatedetail"><b-spinner label="Loading ..."  small class="p-0 mb-1" style="width: 0.6rem; height: 0.6rem;"></b-spinner> </span><span v-if="!loadingupdatedetail"><i class="bx bx-history"></i> </span></b-button>
                </div>
            </div>
              <br><br>
                <div class="media">
                <div class="avatar-sm mr-3">
                  <span class="avatar-title rounded-circle bg-white text-secondary font-size-22">
                    <i class="bx bxs-message bx-lg mb-2"></i>
                  </span>
                </div>
                <div class="media-body">
                <b>{{this.id}}</b>
               <p>{{ $t('telegram.description') }} : {{tableDataGroup.about}}</p>
                </div>
                </div>
              <b-tabs content-class="crypto-buy-sell-nav-content" nav-class="nav-tabs-custom" class="mt-4">
              <b-tab :title="this.$t('telegram.detail.group-static')" active>
                  <div class="row">
                      <div class="col-sm-6 p-5">
                          <h5>{{ $t('telegram.general-number') }} </h5>
                          <table class="table">
                              <tr>     
                                  <td>{{ $t('telegram.messager') }}</td>
                                  <td><b-spinner label="Loading..." v-if="loading && !tableDataGroup[0]" small></b-spinner><b>{{tableDataGroup.message}}</b></td>
                              </tr>
                              <tr> 
                                  <td>{{ tableDataGroup.broadcast ? 'Subscriber' : $t('telegram.member') }}</td>
                                  <td><b-spinner label="Loading..." v-if="loading && !tableDataGroup[0]" small></b-spinner><b>{{tableDataGroup.partisipan}}</b></td>
                              </tr>
                              <tr>
                                  <td>Media</td>
                                  <td><b-spinner label="Loading..." v-if="loading && !tableDataGroup[0]" small></b-spinner><b>{{tableDataGroup.media}}</b></td>
                              </tr>
                              <tr>
                                  <td>{{ $t('telegram.doc') }}</td>
                                  <td><b-spinner label="Loading..." v-if="loading && !tableDataGroup" small></b-spinner><b>{{tableDataGroup.document}}</b></td>
                              </tr>
                              <tr>
                                  <td>Url</td>
                                  <td><b-spinner label="Loading..." v-if="loading && !tableDataGroup[0]" small></b-spinner><b>{{tableDataGroup.url}}</b></td>
                              </tr>
                          </table>
                      </div>
                      <div class="col-sm-6 p-2">
                          <!-- <div class="card border">
                              <div class="card-header bg-dark bg-primary text-white">
                                  Message per Day
                              </div>
                              <div class="card-body">
                                  <div class="col-sm-12">
                                      <apexchart
                                          class="apex-charts"
                                          height="380"
                                          type="line"
                                          dir="ltr"
                                          :series="linewithDataChart.series"
                                          :options="linewithDataChart.chartOptions"
                                      ></apexchart>
                                  </div>
                              </div>
                          </div> -->
                      </div>
                        <!-- <div class="col-sm-6 p-2">
                        <div class="card border h-100">
                              <div class="card-header bg-dark bg-primary text-white">
                                  Time Traffic Activity
                              </div>
                              <div class="card-body">
                                  <apexchart
                                      class="apex-charts"
                                      height="350"
                                      type="bar"
                                      dir="ltr"
                                      :series="columnChart.series"
                                      :options="columnChart.chartOptions"
                                  ></apexchart>
                              </div>
                        </div>
                      </div>
                      <div class="col-sm-6 p-2">
                          <div class="card border">
                              <div class="card-header bg-dark bg-primary text-white">
                                  Member Traffic
                              </div>
                              <div class="card-body">
                                  <div class="col-sm-12">
                                      <apexchart
                                          class="apex-charts"
                                          height="380"
                                          type="line"
                                          dir="ltr"
                                          :series="linewithDataChart.series"
                                          :options="linewithDataChart.chartOptions"
                                      ></apexchart>
                                  </div>
                              </div>
                          </div>
                      </div> -->
                  </div>
                   <div class="row mt-4">
                    <div class="col-lg-12 col-sm-12">
                        <div class="card">
                            <div class="row">
                              <div class="col-sm-6">
                                    <h5 class="p-4">{{ $t('telegram.time-traffic-activity') }}</h5>
                              </div>
                              <div class="col-sm-6 text-right px-4 pt-4">
                              </div>
                          </div>

                               <div class="col-sm-12 p-5 mt-5 mb-5" v-if="loadingheatmap">
                                    <div class="text-center loading mb-3">
                                        <b-spinner label="Loading..."></b-spinner>
                                    </div>
                                </div>
                                <div class="col-sm-12 p-5 mt-5 mb-5" v-if="!loadingheatmap && !cek_heatmap">
                                <div class="text-center loading mb-3">
                                    {{$t('all.dnf')}}
                                </div>
                                </div>
                                <div class="p-4" v-if="!loadingheatmap && cek_heatmap">
                                    <apexchart type="heatmap" height="350" :options="{
                                    chart: {
                                        height: 350,
                                        type: 'heatmap',
                                    },
                                    dataLabels: {
                                        enabled: false
                                    },
                                    colors: ['#bf151c'],
                                        theme: {
                                            mode: theme, 
                                            palette: 'palette1', 
                                            monochrome: {
                                                enabled: false,
                                                color: '#bf151c',
                                                shadeTo: theme,
                                                shadeIntensity: 0.7
                                            },
                                        },
                                    title: {
                                        text:  this.$t('telegram.time-traffic-activity-last'),
                                        align: 'center'
                                    },
                                }" :series="heatmapSeries"></apexchart>
                                </div>
                        </div>
                    </div>
                   </div>
              </b-tab>

              <b-tab :title="this.$t('telegram.detail.list-member')" v-if="!tableDataGroup.broadcast">
                  <div class="card">
                      <div class="card-body">
                            <!-- <a href="javascript: void(0);" class="btn btn-success btn-sm mt-3">
                              <i class="mdi mdi-plus mr-1"></i> Add New
                            </a> -->
                          <div class="row mt-4">
                              <div class="col-sm-12 text-right mb-3">
                                  <span class="text-secondary btn btn-sm btn-light mr-1" v-if="created_at_grouplistmember">{{ $t('telegram.updated') }}: {{formatDateRefresh(created_at_grouplistmember)}}</span> 
                                    <b-button class="btn btn-sm" variant="success" @click="memberListTelegram"><span v-if="loadingupdatemember"><b-spinner label="Loading ..."  small class="p-0 mb-1" style="width: 0.6rem; height: 0.6rem;"></b-spinner> </span><span v-if="!loadingupdatemember"><i class="bx bx-history"></i> </span></b-button>
                              </div>
                            <div class="col-sm-12 col-md-6">
                              <!-- {{tableData}} -->
                              <div id="tickets-table_length" class="dataTables_length">
                                <label class="d-inline-flex align-items-center">
                                  {{ $t('all.show') }}&nbsp;&nbsp;
                                  <b-form-select v-model="perPage" size="md" :options="pageOptions" class="mx-1"></b-form-select>&nbsp;&nbsp;{{ $t('all.entries') }}
                                </label>
                              </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                <label class="d-inline-flex align-items-center">
                                  {{ $t('all.search') }}:
                                  <b-form-input
                                    v-model="filter"
                                    type="search"
                                    :placeholder="$t('all.searchh')"
                                    class="form-control form-control-md ml-2"
                                  ></b-form-input>
                                </label>
                              </div>
                            </div>
                            <!-- End search -->
                          </div>
                          <!-- Table -->
                          <div class="table-responsive mb-0">
                            <b-table
                              :items="tableData"
                              :fields="fields"
                              striped bordered
                              responsive="sm"
                              :per-page="perPage"
                              :current-page="currentPage"
                              :sort-by.sync="sortBy"
                              :sort-desc.sync="sortDesc"
                              :filter="filter"
                              :filter-included-fields="filterOn"
                              @filtered="onFiltered"
                            >
                              <template #cell(group_name)="row">  
                                  <i class="bx bxl-telegram bx-xl bg-primary p-2 text-white rounded mr-2"></i>
                                  {{row.item.group_name}}
                              </template>
                              <template #cell(actions)="row">
                                  <router-link :to="{ name: 'group-view', params: { id: row.item.username }}"><b-button  class="mr-2 btn-sm btn"  variant="light">
                                  <i class="fas fa-eye"></i> Details 
                                  </b-button></router-link>
                              </template>
                            </b-table>
                          </div>
                          <div class="col-sm-12 p-5" v-if="loadinglist && !tableData">
                                <div class="text-center loading">
                                    <b-spinner label="Loading..."></b-spinner>
                                </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <div class="dataTables_paginate paging_simple_numbers float-right">
                                <ul class="pagination pagination-rounded mb-0">
                                  <!-- pagination -->
                                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                  </div>
              </b-tab>

              <b-tab :title="this.$t('telegram.detail.group-chat')">
                  <div class="card">
                      <div class="card-body">
                            <div class="chat-users">
                            <div class="chat-conversation p-3">
                                <div class="row">
                                  <div class="col-sm-12 text-right mb-3">
                                    <span class="text-secondary btn btn-sm btn-light mr-1" v-if="created_at_grouplistchat">{{ $t('telegram.updated') }}: {{formatDateRefresh(created_at_grouplistchat)}}</span> 
                                    <b-button class="btn btn-sm" variant="success" @click="chatListTelegram"><span v-if="loadingupdatechat"><b-spinner label="Loading ..."  small class="p-0 mb-1" style="width: 0.6rem; height: 0.6rem;"></b-spinner> </span><span v-if="!loadingupdatechat"><i class="bx bx-history"></i> </span></b-button>
                                  </div>
                                  <div class="col-sm-12 col-md-6">
                                    <!-- {{tableData}} -->
                                    <div id="tickets-table_length" class="dataTables_length">
                                      <label class="d-inline-flex align-items-center">
                                        {{ $t('all.show') }}&nbsp;&nbsp;
                                        <b-form-select v-model="perPageChat" size="md" :options="pageOptionsChat" class="mx-1"></b-form-select>&nbsp;&nbsp;{{ $t('all.entries') }}
                                      </label>
                                    </div>
                                  </div>
                                  <!-- Search -->
                                  <div class="col-sm-12 col-md-6">
                                    <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                      <label class="d-inline-flex align-items-center">
                                       {{ $t('all.search') }}
                                        <b-form-input
                                          v-model="filterChat"
                                          type="search"
                                          :placeholder="$t('all.searchh')"
                                          class="form-control form-control-md ml-2"
                                        ></b-form-input>
                                      </label>
                                    </div>
                                  </div>
                                  <!-- End search -->
                                </div>
                                <div class="table-responsive mb-0">
                                      <b-table
                                        :items="tableDataChat"
                                        :fields="fieldsChat"
                                        bordered striped
                                        responsive="sm"
                                        :per-page="perPageChat"
                                        :current-page="currentPageChat"
                                        :sort-by.sync="sortByChat"
                                        :sort-desc.sync="sortDescChat"
                                        :filter="filterChat"
                                        :filter-included-fields="filterOnChat"
                                        @filtered="onFilteredChat"
                                      >
                                        <template #cell(date)="row">  
                                        <div class="row">
                                          <div class="col-sm-8">
                                            <b v-if="row.item.username">{{row.item.username}}</b><b v-else>Anonymous</b> <br>
                                            <span claas="text-secondary" v-if="row.item.message">{{row.item.message}}</span><small claas="p-2" v-else>{{ $t('telegram.table.joined')}} </small> 
                                          </div>
                                          <div class="col-sm-4 text-right">
                                              <i class="bx bx-time-five align-middle mr-1"></i>
                                              {{formatDate(row.item.date)}}
                                          </div>
                                        </div>
                                        </template>
                                      </b-table>
                                </div>
                            </div>
                          </div>
                          <div class="col-sm-12 p-5" v-if="loadinglist && !tableDataChat">
                            <div class="text-center loading">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            </div>
                            <div class="float-right pr-3">
                              <ul class="pagination pagination-rounded mb-0">
                                    <!-- pagination -->
                                    <b-pagination v-model="currentPageChat" :total-rows="rowsChat" :per-page="perPageChat"></b-pagination>
                              </ul>
                          </div>
                      </div>
                    </div>
              </b-tab>
              <!-- <b-tab title="Group Document">
                  <div class="card">
                        <b-card class="bg-white" >
                          <b-tabs pills card vertical class="bg-white">
                          <b-tab :title="'Photos ('+tableDataGroup.photos+')'" class="mb-2" active>
                              <div class="row">
                                  <div class="col-sm-4">
                                      <div class="card bg-light p-5">Img</div>
                                  </div>
                                    <div class="col-sm-4">
                                      <div class="card bg-light p-5">Img</div>
                                  </div>
                                    <div class="col-sm-4">
                                      <div class="card bg-light p-5">Img</div>
                                  </div>
                              </div>
                          </b-tab>
                          <b-tab :title="'File ('+tableDataGroup.documents+' )'"><b-card-text>File</b-card-text></b-tab>
                          <b-tab :title="'Video ('+tableDataGroup.video+ ')'"><b-card-text>Video</b-card-text></b-tab>
                          <b-tab :title="'Shared Link ('+tableDataGroup.url+ ')'"><b-card-text>
                              <table class="table table-bordered border-1">
                                  <tr class="bg-white">
                                      <th width="5%" class="text-center">No</th>
                                      <th>Link</th>
                                      <th>Date</th>
                                  </tr>
                                  <tr>
                                      <td class="text-center">1</td>
                                      <td><a href="https://youtu.be/c26EsgAjT4M">https://youtu.be/c26EsgAjT4M</a></td>
                                      <td>Thursday 23/05/2019 02:26 AM</td>
                                  </tr>
                                    <tr>
                                      <td class="text-center">2</td>
                                      <td><a href="https://youtu.be/c26EsgAjT4M">https://youtu.be/c26EsgAjT4M</a></td>
                                      <td>Thursday 23/05/2019 02:26 AM</td>
                                  </tr>
                                    <tr>
                                      <td class="text-center">3</td>
                                      <td><a href="https://youtu.be/c26EsgAjT4M">https://youtu.be/c26EsgAjT4M</a></td>
                                      <td>Thursday 23/05/2019 02:26 AM</td>
                                  </tr>
                              </table>
                              </b-card-text></b-tab>
                          </b-tabs>
                      </b-card>
                  </div>
              </b-tab> -->
              </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import GroupService from "@/helpers/group.service.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PreferenceService from "@/helpers/preference.service.js";
import appConfig from "@/app.config";
import moment from 'moment';

export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    let linewithDataChart = {
        chartOptions: {
        chart: {
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        colors: ['#0067AC', '#34c38f'],
        dataLabels: {
            enabled: false,
        },
        stroke: {
            width: [3, 3],
            curve: 'straight'
        },
        title: {
            text: '',
            align: 'left'
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2
            },
            borderColor: '#f1f1f1'
        },
        markers: {
            style: 'inverted',
            size: 6
        },
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
            title: {
                text: ''
            }
        },
        yaxis: {
            title: {
                text: ''
            },
            min: 5,
            max: 40
        },
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            floating: true,
            offsetY: -25,
            offsetX: -5
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
            }
        }],
    },
    series: [{
        name: "High - 2018",
        data: [4, 11, 32, 36, 31, 10, 33]
    },
    ],
    };

    let columnChart = {
        
    series: [{
        name: 'Net Profit',
        data: [20, 37, 59, 20, 25, 58, 24, 60, 70, 60, 2, 88, 20, 37, 59, 20, 25, 58, 24, 60, 70, 60, 2, 88]
    },],
    chartOptions: {
        chart: {
            toolbar: {
                show: false,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '80%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: ['#0067AC', '#556ee6', '#f46a6a'],
        xaxis: {
            categories: ['00 AM', '02 AM', '04 AM', '06 AM', '08 AM', '10 AM', '12 PM', '14 PM', '16 PM', '18 PM', '20 PM','22 PM'],
        },
        yaxis: {
            title: {
                text: ''
            }
        },
        grid: {
            borderColor: '#f1f1f1',
        },
        fill: {
            opacity: 1

        },
        tooltip: {
            y: {
                formatter: function (val) {
                    return "$ " + val + " thousands"
                }
            }
        }
    }
    }

    return {
      theme: localStorage.getItem('theme'),
      backUrl: "/group-telegram",
      id: this.$route.params.id,
      loading:false,
      loadinglist:false,
      loadingupdatechat:false,
      loadingupdatemember:false,
      loadingupdatedetail:false,
      loadingheatmap:false,
      cek_heatmap:false,
      created_at_grouplistchat:"",
      created_at_grouplistmember:"",
      created_at_grouplistdetail:"",
      tableDataGroup:[],
      tableData:[],
      tableDataChat:[],
      linewithDataChart,
      columnChart,
      totalMember:"",
      elastic:"",
      totalChat:"",
      title: this.$t('telegram.group-messanger-monitor-detail.text'),
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: this.$t('telegram.group-messanger-monitor.text'),
          href: "/group-telegram"
        },
        {
          text:  this.$t('telegram.group-messanger-monitor-detail.text'),
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterChat: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "username", sortable: true,  label: this.$t('telegram.table.username') },
        { key: "first_name", sortable: true,  label: this.$t('telegram.table.first-name')},
        { key: "last_name", sortable: true,  label: this.$t('telegram.table.last-name') },
        { key: "phone", sortable: true,  label: this.$t('telegram.table.phone') }
      ],
      totalRowsChat: 1,
      currentPageChat: 1,
      perPageChat: 10,
      pageOptionsChat: [10, 25, 50, 100],
      filterChat: null,
      filterOnChat: [],
      sortByChat: "age",
      sortDescChat: false,
      fieldsChat: [
        { key: "date", sortable: true, label: this.$t('telegram.table.last-chat') },
        { key: "message_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "message", thClass: 'd-none', tdClass: 'd-none'},
      ],
       heatmapSeries: [
            {
                name: 'Sunday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Monday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Tuesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Wednesday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Thursday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Friday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            },
            {
                name: 'Saturday',
                data: [
                    {x: '00:00',y: 0}, 
                    {x: '01:00',y: 0}, 
                    {x: '03:00',y: 0}, 
                    {x: '04:00',y: 0},
                    {x: '05:00',y: 0}, 
                    {x: '06:00',y: 0}, 
                    {x: '07:00',y: 0},
                    {x: '08:00',y: 0}, 
                    {x: '09:00',y: 0}, 
                    {x: '10:00',y: 0},
                    {x: '11:00',y: 0}, 
                    {x: '12:00',y: 0}, 
                    {x: '13:00',y: 0},
                    {x: '14:00',y: 0}, 
                    {x: '15:00',y: 0}, 
                    {x: '16:00',y: 0},
                    {x: '17:00',y: 0}, 
                    {x: '18:00',y: 0}, 
                    {x: '19:00',y: 0},
                    {x: '20:00',y: 0}, 
                    {x: '21:00',y: 0}, 
                    {x: '22:00',y: 0},
                    {x: '23:00',y: 0}, 
                    {x: '24:00',y: 0}
                ]
            }
        ]
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
     rowsChat() {
      return this.tableDataChat.length;
    }
  },
  mounted() {
    this.getPreferences();
    this.totalRows = this.items.length;
  },
  methods: {
  getPreferences(){ 
        this.loadingheatmap = true;
        PreferenceService.getAllElastic()
        .then((response) => {
            this.elastic = response.data.data[0].ip_address;
            this.getGroupDetail();
            this.memberList();
            this.groupChatList();
            this.getHeatMap();
        })
        .catch((err) => {
            console.log(err);
            this.loadingheatmap = false;
        });
    },
    getGroupDetail(){
        this.loading = true;
          GroupService.getTelegramGroupDetailElastic(this.elastic, this.id)
          .then((response) => {
            console.log('ress=> ', response);
              this.created_at_grouplistdetail = response.data._source.created_at;
              this.tableDataGroup = response.data._source.detail_group;
              this.loading = false; 
              })
              .catch(err => {
                if(err == "Error: Request failed with status code 404"){
                    this.getGroupDetailTelegram();
                } else {
                    console.log(err);
                    this.loading = false; 
                }
          });
    },
    getGroupDetailTelegram(){
        this.loading = true;
        this.loadingupdatedetail = true;
        var data = {
            "group": this.id
        }
          GroupService.getTelegramGroupDetail(data)
            .then((response) => {
                  this.tableDataGroup = response.data.output[0];
                  console.log('tanel data ==> ', this.tableDataGroup);
                  this.loading = false;  
                  this.loadingupdatedetail = false;
                  this.createGroupDetailElastic();
                  var today = new Date();
                  var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                  this.created_at_grouplistdetail = time;
              })
              .catch(err => {
                  this.loading = false;  
                  this.loadingupdatedetail = false;
                  console.log(err);
          });
    },
    createGroupDetailElastic(){
        var today = new Date();
        var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
        const data = {
             "created_at": time,
             "username": this.id,
             "detail_group": this.tableDataGroup
        }
        // console.log(data);
        GroupService.createGroupDetailElastic(this.elastic, this.id, data)
        .then(response => {
            console.log('detail group',response);
        })
        .catch(err => {
            console.log('detail group err ->',err);
        });
    },
    memberList() {
        this.loading = true;
        GroupService.getTelegramGroupMemberElastic(this.elastic, this.id)
            .then((response) => {
                this.created_at_grouplistmember = response.data._source.created_at;
                this.tableData = []
                    response.data._source.listmember.forEach(val => {
                        const data = {    
                        "user_id" : val.user_id,
                        "first_name" : val.first_name,
                        "last_name" : val.last_name,
                        "username" : val.username,
                        "phone" : val.phone,
                        }
                    this.tableData.push(data);
                    this.loadinglist = false;  
                });
            })
            .catch(err => {
                if(err == "Error: Request failed with status code 404"){
                      this.memberListTelegram();
                  } else {
                      console.log(err);
                      this.loading = false; 
                  }
          });
    },
    memberListTelegram() {
        this.loadinglist = true;
        this.loadingupdatemember = true;
        var data = {
            "namagrup": this.id
        }
          GroupService.getTelegramGroupMember(data)
              .then((response) => {
                  this.tableData = []
                  this.member_list = response.data.output;
                  var today = new Date();
                  var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                  this.created_at_grouplistmember = time;
                  this.createMemberElastic();
                    response.data.output.forEach(val => {
                        const data = {    
                        "user_id" : val.user_id,
                        "first_name" : val.first_name,
                        "last_name" : val.last_name,
                        "username" : val.username,
                        "phone" : val.phone,
                        }
                        this.tableData.push(data);
                        this.totalMember = response.data.total_member
                        this.loadinglist = false;  
                        this.loadingupdatemember = false;
                });
                }
                )
                .catch(err => {
                    this.loadinglist = false;  
                    this.loadingupdatemember = false;
                    console.log(err);
            });
    },
    createMemberElastic(){
          var today = new Date();
          var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
          const data = {
             "created_at": time,
             "username": this.id,
             "listmember": this.member_list
        }
        
        GroupService.createGroupMemberElastic(this.elastic, this.id, data)
        .then(response => {
            // console.log('create member',response);
        })
        .catch(err => {
            console.log('member list err ->',err);
        });
    },
    groupChatList() {
        GroupService.getTelegramChatElastic(this.elastic, this.id)
        .then((response) => {
              this.created_at_grouplistchat = response.data._source.created_at;
                  this.tableDataChat = []
                    response.data._source.listchat.forEach(val => {
                        const data = {    
                        "message_id" : val.message_id,
                        "date" : val.date,
                        "message" : val.message,
                        "username" : val.username,
                        }
                        this.tableDataChat.push(data);
                        this.loadinglist = false;  
                });
            })
            .catch(err => {
              if(err == "Error: Request failed with status code 404"){
                    this.chatListTelegram();
                } else {
                    console.log(err);
                    this.loading = false; 
                }
          });
    },
    chatListTelegram() {
      this.loadinglist = true;
      this.loadingupdatechat = true;
        var data = {
            "group": this.id
        }
            GroupService.getTelegramGroupChat(data)
            .then((response) => {
                  this.tableDataChat = []
                  this.chat_list = response.data.output;
                  
                  var today = new Date();
                  var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
                  this.created_at_grouplistchat = time;
                  this.createChatElastic();
                    response.data.output.forEach(val => {
                        const data = {    
                        "message_id" : val.message_id,
                        "date" : val.date,
                        "message" : val.message,
                        "username" : val.username,
                        }
                        this.tableDataChat.push(data);
                        this.totalChat = response.data.Total_message
                        this.loadinglist = false;
                        this.loadingupdatechat = false;  
                });
                })
                .catch(err => {
                    this.loadinglist = false;  
                    this.loadingupdatechat = false;
                    console.log(err);
            });
    },
    createChatElastic(){
          var today = new Date();
          var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
          const data = {
             "created_at": time,
             "username": this.id,
             "listchat": this.chat_list
        }
        GroupService.createGroupChatElastic(this.elastic, this.id, data)
        .then(response => {
            // console.log('create chat',response);
            this.loadingupdatechat = false; 
            this.getHeatMap();
        })
        .catch(err => {
            console.log('chat err ->',err);
            this.loadingupdatechat = false;  
        });
    },

    //heatmap
    getHeatMap(){
        this.loadingheatmap = true;
        GroupService.getHeatMapElastic(this.elastic, this.id)
        .then(response => {
                this.cek_heatmap = true;
                response.data._source.heatmap.forEach(element => {
                this.heatmapSeries.forEach(series => {
                    if(element.day == series.name){
                        series.data.forEach(d => {
                            if (d.x == element.hour+':00') {
                                d.y = element.count
                            }
                        });
                    }
                });
            });
            this.loadingheatmap = false;
        })
        .catch(err => {
            console.log(err);
            if(err == "Error: Request failed with status code 404"){
                this.getHeatMapTele();
            } else {
                console.log(err);
                this.loadingheatmap = false;
            }
        });
    },
    getHeatMapTele(){
        const data = {
            'group' : this.id
        }
        // console.log(data);
        GroupService.getHeatMap(data)
        .then(response => {    
            this.heatmap = response.data.output;
            response.data.output.forEach(element => {
                this.heatmapSeries.forEach(series => {
                    if(element.day == series.name){
                        series.data.forEach(d => {
                            if (d.x == element.hour+':00') {
                                d.y = element.count
                            }
                        });
                    }
                });
            });
            this.cek_heatmap = true;
            this.createUserHeatmap();
        })
        
        .catch(err => {
            console.log('heatmap err ->',err);
            this.loadingheatmap = false;
        })
    },
    createUserHeatmap(){
          var heatmap = this.heatmap;
          var today = new Date();
          var time = today.toLocaleString('en-US', { timeZone: 'Asia/Jakarta' });
          const data = {
             "created_at": time,
             "username": this.id,
             "heatmap": heatmap
        }
        GroupService.createHeatMapElastic(this.elastic, this.id, data)
        .then(response => {
            this.created_at_heatmap = time;
            this.loadingheatmap = false;
        })
        .catch(err => {
            console.log('timeline err ->',err);
            this.loadingheatmap = false;
        });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFilteredChat(filteredItemsChat) {
      this.totalRowsChat = filteredItemsChat.length;
      this.currentPageChat = 1;
    },
    onDelete(id){
        console.log('delete data:', id);
    },
    onView(id){
        console.log('details data:', id);
    },
    formatDate(value){
        return moment(value).format("YYYY-MM-DD, hh:mm");
    },
    formatDateRefresh(value){
        return moment(value).format("YYYY-MM-DD, hh:mm");
    },
  }
};
</script>

<style scoped>
.badge{
    border-radius: 2%;
}
.btn{
    border-radius: 7%;
}
.card{
      box-shadow: 0 0 10px 0 rgba(100, 100, 100, 0.11);
}
.bg-dark{
    background-color: #2A3042;
}
</style>